import { PlusIcon } from '../../assets/svg';

interface DropdownItemProps{
  variant?: "default" | "add_new",
  isActive?: boolean,
  title?: string,
  allPlusIcon?: boolean,
  onSelectDropdown?: () => void,
  onMouseEnter?:() => void
}

function DropdownItem({variant="default", allPlusIcon=false,...props}: DropdownItemProps) {
  let title = props.title ? props.title : "title";
  if(variant === "default"){
    return (
      <div onMouseEnter={props?.onMouseEnter} onClick={props.onSelectDropdown} className={'py-3 px-4 polymer_dropdown_selector-items' + (allPlusIcon === true && ' polymer_dropdown_selector-add-items')} style={{background:props.isActive ? "#EFF8FA" : undefined}}>
        {allPlusIcon === true && <PlusIcon />}
        <p className='m-0' style={title === "Not applicable" ? {fontWeight:700} : {}}>{title}</p>
      </div>
    )
  }
  else if(variant === "add_new"){
    return (
      <div onMouseEnter={props?.onMouseEnter} onClick={props.onSelectDropdown} className='d-flex py-3 px-4 polymer_dropdown_selector-add-items' style={{background:props.isActive ? "#EFF8FA" : undefined}}>
        <PlusIcon/>
        <p className='m-0 font-weight-bold'>{title}</p>
      </div>
    )
  }
  else{
    return (<>
    </>)
  }
}

export default DropdownItem